
export default {
    title: {
        id: 'MEDCAL_RX_FILE_LIST_TITLE',
        defaultMessage: 'Uploaded Files:',
    }
}